import React, { useRef, useEffect } from "react";
import * as echarts from "echarts";
import { Empty, Ellipsis } from "antd-mobile";
import zIcon from "../img/z-icon.png";
import fenbu from "../img/fenbu.png";
import titleIcon from "../img/titleIcon.png";
import typeIcon from "../img/type.png";
import ZitemICon from "../img/z-itemIcon.png";
import zjIcon from "../img/zjIcon.png";
import { colors, imgColors } from "../../carbonNeutrality";
import { disposeColors } from "pages/CarbonNeutralityDisclosure/config";

/**
 * 碳排放详情
 * @param {*} props
 * @returns
 */
export default function CarbonDistribution(props) {
  const chartPie = useRef(null);
  const chartRose = useRef(null);
  const { dataVal, type } = props;

  useEffect(() => {
    const data = disposeCharData(dataVal?.pubEmissionCarbons);
    if (!chartPie.current || data?.pieList?.length === 0) return;
    // 创建图表实例
    const chart = echarts.init(chartPie.current);
    const maxValue = data?.pieList?.reduce((prev, current) => {
      return +prev.carbon > +current.carbon ? prev : current;
    });
    const name =
      maxValue?.name?.length > 6
        ? `${maxValue?.name?.substring(0, 6)}...`
        : maxValue?.name;
    const value =
      `${maxValue?.carbon}`?.length > 6
        ? `${`${maxValue?.carbon}`?.substring(0, 6)}...`
        : `${maxValue?.carbon}`;
    // 准备数据和配置选项
    const options = {
      color: disposeColors(type).colorList,
      tooltip: false,
      grid: {
        containLabel: true, // 确保图表内容完全包含在容器中
        left: "0",
        right: "0",
        top: "0",
        bottom: "0",
      },
      legend: false,
      series: [
        {
          selectedMode: "single",
          radius: [40, 70],
          name: "Access From",
          type: "pie",
          labelLayout: function (params) {
            const isLeft = params.labelRect.x < chart.getWidth() / 2;
            const points = params.labelLinePoints;
            // Update the end point.
            points[2][0] = isLeft
              ? params.labelRect.x
              : params.labelRect.x + params.labelRect.width;
            return {
              labelLinePoints: points,
            };
          },
          data: data?.pieList,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
          label: {
            alignTo: "edge",
            formatter: function (params) {
              const carbon = params?.data?.carbon;
              return [`{a|${carbon}%}`, `{b|${params.name}}`].join("\n");
            },
            minMargin: 5,
            edgeDistance: 10,
            lineHeight: 15,
            rich: {
              a: {
                // fontSize: '0.32rem',
                color: "#333333",
              },
              b: {
                // fontSize: '0.29rem',
                color: "#666666",
              },
            },
          },
        },
      ],
      graphic: [
        {
          type: "text",
          left: "center",
          top: "90px",
          style: {
            text: name,
            textAlign: "center",
            fill: "#666666",
            fontSize: 8,
          },
        },
        {
          type: "text",
          left: "center",
          top: "center",
          style: {
            text: `${value}%`,
            textAlign: "center",
            fill: "#333333",
            fontSize: 12,
            fontWeight: "bold",
          },
        },
      ],
    };

    // 监听点击事件
    chart.on("click", function (params) {
      if (params.seriesType === "pie") {
        const name =
          params?.data?.name?.length > 6
            ? `${params?.data?.name?.substring(0, 6)}...`
            : params?.data?.name;
        const carbon =
          `${params?.data?.carbon}`?.length > 6
            ? `${`${params?.data?.carbon}`?.substring(0, 6)}...`
            : params?.data?.carbon;
        chart.setOption({
          graphic: [
            {
              type: "text",
              left: "center",
              top: "90px",
              style: {
                text: name,
                textAlign: "center",
                fill: "#666666",
                fontSize: 8,
              },
            },
            {
              type: "text",
              left: "center",
              top: "center",
              style: {
                text: `${carbon}%`,
                textAlign: "center",
                fill: "#333333",
                fontSize: 12,
                fontWeight: "bold",
              },
            },
          ],
        });
      }
    });
    chart.setOption(options);
    // // 可选：响应式调整图表大小（如果需要自适应大小）
    window.addEventListener("resize", () => chart.resize());
  }, [dataVal]);

  useEffect(() => {
    const data = disposeCharData(dataVal?.pubEmissionCarbons);
    if (!data?.roseList?.length) return;
    if (!chartPie.current) return;
    // 创建图表实例
    const chart = echarts?.init(chartRose.current);
    // // 准备数据和配置选项
    const options = {
      series: [
        {
          color: disposeColors(type).colorList,
          name: "Radius Mode",
          type: "pie",
          radius: [30, 100],
          // center: ['25%', '50%'],
          roseType: "radius",
          itemStyle: {
            borderRadius: 10,
          },
          label: false,
          emphasis: false,
          data: data?.roseList,
        },
      ],
    };
    chart.setOption(options);
    // // 可选：响应式调整图表大小（如果需要自适应大小）
    window.addEventListener("resize", () => chart.resize());
  }, [dataVal]);

  const disposeCharData = (data) => {
    const pieList = [];
    const roseList = [];
    data?.forEach((item, i) => {
      if (i === 0) {
        pieList.push({
          name: item?.name,
          value: +item?.ratio,
          carbon: item?.ratio,
          // selected: true,
        });
      } else {
        pieList.push({
          name: item?.name,
          value: +item?.ratio,
          carbon: item?.ratio,
        });
      }
      item?.children?.map((subItem) => {
        roseList.push({
          name: subItem?.name,
          value: +subItem?.ratio,
          carbon: subItem?.ratio,
        });
      });
    });
    return { pieList, roseList };
  };
  return (
    <div
      className="discharge-item"
      style={{
        backgroundImage:
          type === "1"
            ? "linear-gradient(180deg, #E8EFF4 0%, #FFFFFF 100%)"
            : "linear-gradient(180deg, #e8f4ef 0%, #ffffff 100%)",
      }}
    >
      <div className="item-header">
        <div className="item-title">
          {type !== "1" ? (
            <img src={titleIcon} alt="" />
          ) : (
            <img src={zIcon} alt="" />
          )}
          <span style={{ color: type === "1" ? "#1677D0" : "#00a15e" }}>
            碳排放分布
          </span>
        </div>
        <div
          className="item-icon"
          style={{
            backgroundImage: `url(${type === "1" ? fenbu : zjIcon})`,
          }}
        >
          <span>单位：tCO₂e</span>
        </div>
      </div>
      {type === "1" && (
        <div className="neutralization-content">
          <div className="neutralization-title">{dataVal?.emissionCarbon}</div>
          <div className="neutralization-value">
            {dataVal?.year}年度温室气体排放量汇总
          </div>
        </div>
      )}
      <div className="distribution-wrapper">
        {dataVal?.pubEmissionCarbons &&
          dataVal?.pubEmissionCarbons?.map((item, idex) => {
            const { colorList, imgColorsList } = disposeColors(type);
            const colorIndex = idex % colorList?.length;
            // const colorIndex = idx % colors.length;
            // const subTitle = item?.children?.[0]?.name;
            return (
              <div className="distribution-item">
                <div
                  className="distribution-title"
                  style={{ background: colorList?.[colorIndex] }}
                >
                  <div className="sub-title">
                    <div>
                      <Ellipsis direction="end" rows={2} content={item?.name} />
                    </div>
                    {/* <div style={{ opacity: '0.8', fontSize: '0.32rem' }}>
                      <Ellipsis direction="end" rows={2} content={subTitle} />
                    </div> */}
                  </div>
                  <div className="sub-value" style={{ color: "#fff" }}>
                    {item?.carbon}
                  </div>
                </div>
                <div
                  className="distribution-content"
                  style={{ background: imgColorsList?.[colorIndex] }}
                >
                  {item?.children?.map((subItem, i) => {
                    const marBtn = i === item?.children?.length - 1;
                    return (
                      <div
                        className="distribution-content-item"
                        style={{ marginBottom: marBtn ? "0rem" : "0.32rem" }}
                      >
                        <div className="sub-title">
                          <Ellipsis
                            direction="end"
                            rows={2}
                            content={subItem?.name}
                          />
                        </div>
                        <div
                          className="sub-value"
                          style={{ color: colorList?.[colorIndex] }}
                        >
                          {subItem?.carbon}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
      </div>
      <div
        className="chart-pie"
        style={{
          backgroundImage:
            type === "1"
              ? "linear-gradient(180deg, #ECF6FF 0%, #F1FCFF 100%), linear-gradient(180deg, #DBF4EA 0%, #F3FCF8 100%)"
              : "linear-gradient(180deg, #dbf4ea 0%, #f3fcf8 100%)",
        }}
      >
        <div
          className="pie-title"
          style={{ color: type === "1" ? "#1677D0" : "#00a15e" }}
        >
          碳排放类别占比
        </div>
        {disposeCharData(dataVal?.pubEmissionCarbons)?.pieList?.length ? (
          <div
            id="chart-pie"
            className="chart-pie-content"
            ref={chartPie}
          ></div>
        ) : (
          <Empty />
        )}
      </div>
      <div
        className="chart-pie"
        style={{
          marginTop: "0.21rem",
          backgroundImage:
            type === "1"
              ? "linear-gradient(180deg, #ECF6FF 0%, #F1FCFF 100%), linear-gradient(180deg, #DBF4EA 0%, #F3FCF8 100%)"
              : "linear-gradient(180deg, #dbf4ea 0%, #f3fcf8 100%)",
        }}
      >
        <div
          className="pie-title"
          style={{ color: type === "1" ? "#1677D0" : "#00a15e" }}
        >
          碳排放结构占比
        </div>
        {disposeCharData(dataVal?.pubEmissionCarbons)?.roseList?.length ? (
          <div
            id="chart-rose"
            className="chart-pie-content"
            ref={chartRose}
          ></div>
        ) : (
          <Empty />
        )}
        <div className="type-list">
          {disposeCharData(dataVal?.pubEmissionCarbons)?.roseList?.map(
            (item, idx) => {
              const { colorList, imgColorsList } = disposeColors(type);
              const colorIndex = idx % colorList?.length;
              return (
                <div className="type-item">
                  <div className="type-item-type">
                    <span
                      className="icon-value"
                      style={{ backgroundColor: colorList?.[colorIndex] }}
                    ></span>
                    <span className="item-type-text">
                      <Ellipsis direction="end" content={item?.name} />
                    </span>
                  </div>
                  <div className="ratio">{item?.carbon}%</div>
                </div>
              );
            }
          )}
        </div>
      </div>
    </div>
  );
}
